<mat-card appearance="outlined">
  <mat-card-header>
    <div class="header-nombre-nuevo">
      <h2>Anotaciones</h2>
      <app-button-new
        *appRoles="['ExpedientesNotas.Crear']"
        matTooltip="Nueva nota"
        (click)="openDialog('Agregar', {})">
      </app-button-new>
    </div>
  </mat-card-header>

  <mat-card-content *appRoles="['ExpedientesNotas.Listar']">
    <ngx-spinner
      [zIndex]="100"
      name="spLoadList"
      bdColor="rgba(255,255,255,0.8)"
      size="default"
      color="var(--primary-color)"
      type="ball-atom"
      [fullScreen]="false">
    </ngx-spinner>

    <div class="nota-container">
      <div class="nota" *ngFor="let item of expedienteNotas">
        <mat-accordion *appRoles="['ExpedientesNotas.Ver']">
          <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
            <mat-expansion-panel-header>



              <!-- 📝 Título y descripción -->
              <mat-panel-title>
                <app-avatar-iniciales [nombre]='item.creadoPor?.nombre' [apellido]='item.creadoPor?.apellido' ></app-avatar-iniciales>
                <div class="detalle-nota">
                      {{ getDescripcionCorta(item.descripcion, 50) }}
                </div>

              </mat-panel-title>
              <mat-panel-description>
                Creado: {{ item.fechaAlta | date: 'short' }}
              </mat-panel-description>

            </mat-expansion-panel-header>

            <!-- 💬 Descripción de la nota -->
            <div [innerHTML]="item.descripcion"></div>

            <!-- 🔧 Acciones -->
            <mat-action-row>
              <app-button-edit
                (click)="openDialog('Modificar',{item})"
                *appRoles="['ExpedientesNotas.Modificar']">
              </app-button-edit>

              <app-button-delete
                (click)="openDialog('Eliminar',{item})"
                *appRoles="['ExpedientesNotas.Eliminar']">
              </app-button-delete>
            </mat-action-row>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  </mat-card-content>
</mat-card>
